/**
 * Distinguishes "the backend is unreachable" from "the backend answered and said
 * no". This matters at login: a Firebase sign-in can succeed while the pop.in
 * GraphQL endpoint is unreachable (network down, backend not running). That is NOT
 * an authorization failure — we must keep the Firebase session and show an
 * interstitial, rather than signing the user back out.
 */
export class BackendUnavailableError extends Error {
  constructor(message = "The pop.in backend is currently unreachable.", options?: { cause?: unknown }) {
    super(message);
    this.name = "BackendUnavailableError";
    if (options?.cause !== undefined) this.cause = options.cause;
  }
}

/** True when the error means we couldn't reach the backend at all. */
export function isBackendUnavailable(error: unknown): error is BackendUnavailableError {
  return error instanceof BackendUnavailableError;
}
